import Vue from 'vue';
import Toast, { TYPE } from 'vue-toastification';

Vue.use(Toast, {
    timeout: 6000,
    hideProgressBar: true,
    icon: false,
    draggable: false,
    containerClassName: 'vue-need-bootstrap',
    toastDefaults: {
        [TYPE.ERROR]: {
            timeout: 10000,
            toastClassName: 'bg-red'
        }
    }
});
